import { render } from "./EditValsInput.vue?vue&type=template&id=97ca1ea2"
import script from "./EditValsInput.vue?vue&type=script&lang=js"
export * from "./EditValsInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__